import React, { useState, useRef, useLayoutEffect, useEffect } from 'react';

import {
  Description,
  MyLocation,
  Check,
  LocalGasStation,
  Opacity,
  CalendarToday,
} from '@material-ui/icons';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';

import * as S from './styles';

function CardRecebimento({ params }) {
  const [headerHeight, setHeaderHeight] = useState('50px');
  const headerRef = useRef(null);

  useLayoutEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(`${headerRef.current.offsetHeight}px`);
    }
  }, []);

  return (
    <S.Wrapper>
      <header>
        <div className="title" ref={headerRef}>
          <Description style={{ fontSize: 20 }} />
          <h1>{params.nfdescarganf}</h1>
        </div>
      </header>

      <S.Container style={{ '--header-height': headerHeight }}>
        <hgroup>
          <h1>{number(params.percentual, 2)}</h1>
          <h2>%</h2>
        </hgroup>

        <S.WrapperLinhaVolumes>
          <S.WrapperVolume>
            <MyLocation style={{ color: 'green', fontSize: 20 }} />
            <p>{t('s.dashboard.visaogeral.esperado')}</p>
            <strong>{number(params.volumenfdescarganf)} L</strong>
          </S.WrapperVolume>
          <S.SeparadorVolumes />
          <S.WrapperVolume>
            <Check color="error" style={{ fontSize: 20 }} />
            <p>{t('s.relatorio.geral.recebido')}</p>
            <strong> {number(params.volumefisicodescarganf)} L</strong>
          </S.WrapperVolume>
        </S.WrapperLinhaVolumes>
        <S.WrapperInfo>
          <p>
            {t('s.dashboard.visaogeral.diferencalitros')}
            <strong>
              {number(
                params.volumenfdescarganf - params.volumefisicodescarganf
              )}{' '}
              L
            </strong>
          </p>
          <S.LinhaIconeTexto>
            <LocalGasStation color="primary" style={{ fontSize: 16 }} />
            <p>{params.nomeabreviadoposto}</p>
          </S.LinhaIconeTexto>
          <S.LinhaIconeTexto>
            <Opacity style={{ fontSize: 16, color: '#DFCC27' }} />
            <p>{params.nomeabreviadoproduto}</p>
          </S.LinhaIconeTexto>
          <S.LinhaIconeTexto>
            <CalendarToday style={{ fontSize: 16, color: '#4791db' }} />
            <p>{params.datahorainiciodescarganf.slice(0, -3)}</p>
          </S.LinhaIconeTexto>
        </S.WrapperInfo>
      </S.Container>
    </S.Wrapper>
  );
}

CardRecebimento.propTypes = {
  params: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default CardRecebimento;
